import { useDispatch, useSelector } from "react-redux"
import { obtenerComisionesFiltro } from "../../../ducks/cotizacionDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { Grid } from "@material-ui/core"
import PickerMod from "../../../global/PickersMod"
import { esFechaValida } from "../../../utils/FormatFecha"

const FiltroFecha = () => {
    const dispatch = useDispatch()
    const { fechaFiltro } = useSelector(store => store.cotizacion)
    const handleChangeFechaMesFin = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerComisionesFiltro({ fechaFiltro: date })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    return (
        <PickerMod
            id="fechamesComisionesPagar"
            label="Mes"
            selectedDate={fechaFiltro}
            setSelectedDate={handleChangeFechaMesFin}
            disablePast={false}
            disableFuture={true}
            formatFecha={"MM/yyyy"}
            views={["year", "month"]}
        />
    )
}
export default FiltroFecha